// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  height: 100%;
}

.responsive-grid {
  width: 100%;
  height: 100%;
  display: block;
}

.ag-root {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
@media (max-width: 599px) {
  .ag-root {
    width: 100%;
    height: auto;
    overflow: hidden;
  }
}

.ag-body-viewport {
  overflow-x: auto !important;
  overflow-y: auto !important;
  width: 100%;
  height: 100%;
}
@media (max-width: 599px) {
  .ag-body-viewport {
    overflow-x: scroll !important;
    overflow-y: auto !important;
    width: 100%;
    height: 100%;
    -webkit-overflow-scrolling: touch;
  }
}

.ag-body-horizontal-scroll {
  display: block !important;
  min-height: 12px;
}
@media (min-width: 1024px) {
  .ag-body-horizontal-scroll {
    display: block !important;
    min-height: 12px;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .ag-body-horizontal-scroll {
    display: block !important;
    min-height: 12px;
  }
}
@media (max-width: 599px) {
  .ag-body-horizontal-scroll {
    display: block !important;
    min-height: 12px;
  }
}

.ag-cell {
  line-height: 1.2;
  font-size: clamp(4px, 1.7vmin, 18px);
  padding: 4px 6px;
}
@media (max-width: 599px) {
  .ag-cell {
    font-size: clamp(8px, 2.2vmin, 16px);
    padding: 4px 4px;
  }
}

.ag-header-cell-label {
  font-size: clamp(5px, 1.8vmin, 20px);
  line-height: 1.2;
}
@media (max-width: 599px) {
  .ag-header-cell-label {
    font-size: clamp(8px, 2.2vmin, 16px);
  }
}

.ag-header-row {
  background-color: white;
}

.ag-header-cell {
  padding: 4px 6px !important;
  background-color: white;
  border-bottom: 1px solid #e0e0e0;
}
@media (max-width: 599px) {
  .ag-header-cell {
    padding: 4px 4px !important;
  }
}

.ag-paging-panel {
  font-size: 13px;
  height: auto;
  min-height: 38px;
  background: white;
  border-top: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  gap: 8px;
}
@media (max-width: 599px) {
  .ag-paging-panel {
    font-size: 12px;
    padding: 4px 6px;
    gap: 6px;
    min-height: 36px;
  }
}

.ag-paging-row-summary-panel {
  font-size: 12px;
  color: #333;
  white-space: nowrap;
}
@media (max-width: 599px) {
  .ag-paging-row-summary-panel {
    font-size: 11px;
  }
}

.ag-paging-page-summary-panel {
  font-size: 12px;
  color: #333;
  white-space: nowrap;
}
@media (max-width: 599px) {
  .ag-paging-page-summary-panel {
    font-size: 11px;
  }
}

.ag-paging-button {
  font-size: 12px;
}
@media (max-width: 599px) {
  .ag-paging-button {
    font-size: 11px;
  }
}

.ag-wrapper {
  font-size: 13px;
  color: #333;
}
@media (max-width: 599px) {
  .ag-wrapper {
    font-size: 12px;
  }
}

.ag-paging-page-size {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  font-size: 12px;
  color: #333;
}
@media (max-width: 599px) {
  .ag-paging-page-size {
    gap: 4px;
    font-size: 11px;
  }
}

.ag-picker-field-wrapper {
  height: auto;
}

.ag-select {
  font-size: 12px !important;
  height: 30px !important;
  min-height: 30px !important;
  color: #333;
}
@media (max-width: 599px) {
  .ag-select {
    font-size: 11px !important;
    height: 28px !important;
    min-height: 28px !important;
  }
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/logbooks/components/datatable/datatable.component.scss","webpack://./src/theme/mocca-breakpoints.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,WAAA;EACA,YAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;AADJ;ACSE;EDXF;IAMQ,WAAA;IACA,YAAA;IACA,gBAAA;EAAN;AACF;;AAGA;EACI,2BAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AAAJ;ACLE;EDCF;IAOQ,6BAAA;IACA,2BAAA;IACA,WAAA;IACA,YAAA;IACA,iCAAA;EACN;AACF;;AAEA;EACI,yBAAA;EACA,gBAAA;AACJ;ACLE;EDEF;IAKQ,yBAAA;IACA,gBAAA;EAEN;AACF;AClBE;EDSF;IAUQ,yBAAA;IACA,gBAAA;EAGN;AACF;AC/BE;EDgBF;IAeQ,yBAAA;IACA,gBAAA;EAIN;AACF;;AADA;EACI,gBAAA;EACA,oCAAA;EACA,gBAAA;AAIJ;AC3CE;EDoCF;IAMQ,oCAAA;IACA,gBAAA;EAKN;AACF;;AAFA;EACI,oCAAA;EACA,gBAAA;AAKJ;ACtDE;ED+CF;IAKQ,oCAAA;EAMN;AACF;;AAHA;EACI,uBAAA;AAMJ;;AAHA;EACI,2BAAA;EACA,uBAAA;EACA,gCAAA;AAMJ;ACrEE;ED4DF;IAMQ,2BAAA;EAON;AACF;;AAJA;EACI,eAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;AAOJ;ACtFE;EDsEF;IAYQ,eAAA;IACA,gBAAA;IACA,QAAA;IACA,gBAAA;EAQN;AACF;;AALA;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AAQJ;ACpGE;EDyFF;IAMQ,eAAA;EASN;AACF;;AANA;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AASJ;AC/GE;EDmGF;IAMQ,eAAA;EAUN;AACF;;AAPA;EACI,eAAA;AAUJ;ACxHE;ED6GF;IAIQ,eAAA;EAWN;AACF;;AARA;EACI,eAAA;EACA,WAAA;AAWJ;AClIE;EDqHF;IAKQ,eAAA;EAYN;AACF;;AATA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAYJ;AChJE;ED8HF;IASQ,QAAA;IACA,eAAA;EAaN;AACF;;AAVA;EACI,YAAA;AAaJ;;AAVA;EACI,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;AAaJ;ACjKE;EDgJF;IAOQ,0BAAA;IACA,uBAAA;IACA,2BAAA;EAcN;AACF;;AAXA,sEAAA;AAEA,wBAAA;AAEE,2DAAA;AAGF,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AAIF,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AAIF,4BAAA","sourcesContent":["@use 'src/theme/mocca-breakpoints' as bp;\r\n\r\n:host {\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.responsive-grid {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\n\r\n.ag-root {\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: hidden;\r\n\r\n    @include bp.mobile {\r\n        width: 100%;\r\n        height: auto;\r\n        overflow: hidden;\r\n    }\r\n}\r\n\r\n.ag-body-viewport {\r\n    overflow-x: auto !important;\r\n    overflow-y: auto !important;\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    @include bp.mobile {\r\n        overflow-x: scroll !important;\r\n        overflow-y: auto !important;\r\n        width: 100%;\r\n        height: 100%;\r\n        -webkit-overflow-scrolling: touch;\r\n    }\r\n}\r\n\r\n.ag-body-horizontal-scroll {\r\n    display: block !important;\r\n    min-height: 12px;\r\n\r\n    @include bp.desktop {\r\n        display: block !important;\r\n        min-height: 12px;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        display: block !important;\r\n        min-height: 12px;\r\n    }\r\n\r\n    @include bp.mobile {\r\n        display: block !important;\r\n        min-height: 12px;\r\n    }\r\n}\r\n\r\n.ag-cell {\r\n    line-height: 1.2;\r\n    font-size: clamp(4px, 1.7vmin, 18px);\r\n    padding: 4px 6px;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(8px, 2.2vmin, 16px);\r\n        padding: 4px 4px;\r\n    }\r\n}\r\n\r\n.ag-header-cell-label {\r\n    font-size: clamp(5px, 1.8vmin, 20px);\r\n    line-height: 1.2;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(8px, 2.2vmin, 16px);\r\n    }\r\n}\r\n\r\n.ag-header-row {\r\n    background-color: white;\r\n}\r\n\r\n.ag-header-cell {\r\n    padding: 4px 6px !important;\r\n    background-color: white;\r\n    border-bottom: 1px solid #e0e0e0;\r\n\r\n    @include bp.mobile {\r\n        padding: 4px 4px !important;\r\n    }\r\n}\r\n\r\n.ag-paging-panel {\r\n    font-size: 13px;\r\n    height: auto;\r\n    min-height: 38px;\r\n    background: white;\r\n    border-top: 1px solid #e0e0e0;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 4px 8px;\r\n    gap: 8px;\r\n\r\n    @include bp.mobile {\r\n        font-size: 12px;\r\n        padding: 4px 6px;\r\n        gap: 6px;\r\n        min-height: 36px;\r\n    }\r\n}\r\n\r\n.ag-paging-row-summary-panel {\r\n    font-size: 12px;\r\n    color: #333;\r\n    white-space: nowrap;\r\n\r\n    @include bp.mobile {\r\n        font-size: 11px;\r\n    }\r\n}\r\n\r\n.ag-paging-page-summary-panel {\r\n    font-size: 12px;\r\n    color: #333;\r\n    white-space: nowrap;\r\n\r\n    @include bp.mobile {\r\n        font-size: 11px;\r\n    }\r\n}\r\n\r\n.ag-paging-button {\r\n    font-size: 12px;\r\n\r\n    @include bp.mobile {\r\n        font-size: 11px;\r\n    }\r\n}\r\n\r\n.ag-wrapper {\r\n    font-size: 13px;\r\n    color: #333;\r\n\r\n    @include bp.mobile {\r\n        font-size: 12px;\r\n    }\r\n}\r\n\r\n.ag-paging-page-size {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    white-space: nowrap;\r\n    font-size: 12px;\r\n    color: #333;\r\n\r\n    @include bp.mobile {\r\n        gap: 4px;\r\n        font-size: 11px;\r\n    }\r\n}\r\n\r\n.ag-picker-field-wrapper {\r\n    height: auto;\r\n}\r\n\r\n.ag-select {\r\n    font-size: 12px !important;\r\n    height: 30px !important;\r\n    min-height: 30px !important;\r\n    color: #333;\r\n\r\n    @include bp.mobile {\r\n        font-size: 11px !important;\r\n        height: 28px !important;\r\n        min-height: 28px !important;\r\n    }\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 800px) or (max-height: 550px) {\r\n  }\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 800px) and (min-height: 550px) {\r\n  }\r\n\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1000px) and (min-height: 600px) {\r\n  }\r\n\r\n/*#endregion Larger Screens*/","// =============================================================================\r\n//  accord-breakpoints.scss\r\n//\r\n//  Standard 3-tier Responsive Breakpoints for the Accord Design System.\r\n//  Based on Google Material Design 3 guidelines.\r\n//\r\n//  Breakpoints:\r\n//    Mobile  — max-width: 599px\r\n//    Tablet  — min-width: 600px and max-width: 1023px\r\n//    Desktop — min-width: 1024px\r\n//\r\n//  Usage in component SCSS (with @use):\r\n//    @use 'src/theme/mocca-breakpoints' as bp;\r\n//    @include bp.mobile  { ... }\r\n//    @include bp.tablet  { ... }\r\n//    @include bp.desktop { ... }\r\n//\r\n//  Or via raw @media (legacy/global):\r\n//    @media (max-width: 599px)                        { ... }  // mobile\r\n//    @media (min-width: 600px) and (max-width: 1023px){ ... }  // tablet\r\n//    @media (min-width: 1024px)                       { ... }  // desktop\r\n// =============================================================================\r\n\r\n/// Mobile only — screens ≤ 599px\r\n@mixin mobile {\r\n  @media (max-width: 599px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet only — screens 600px–1023px\r\n@mixin tablet {\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and above — screens ≥ 1024px\r\n@mixin desktop {\r\n  @media (min-width: 1024px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet and above — screens ≥ 600px (tablet + desktop)\r\n@mixin tablet-up {\r\n  @media (min-width: 600px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and below — screens ≤ 1023px (mobile + tablet)\r\n@mixin desktop-down {\r\n  @media (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
